const PRODUCTION_HOSTNAME = 'registration.masterplumbers.asn.au';

export function isAnalyticsEnabled() {
  return typeof window !== 'undefined' && window.location.hostname === PRODUCTION_HOSTNAME;
}

export function isRegistrationRoute(path) {
  return /^\/register\/(plumber|associate|retired|teacher)(?:\/|$)/.test(path);
}

function canTrack() {
  return isAnalyticsEnabled() && typeof window.gtag === 'function';
}

function logSkipped(eventName, reason) {
  console.info(`[GA4] Skipped ${eventName}: ${reason}`);
}

export function trackPageView() {
  if (!canTrack()) {
    logSkipped('page_view', isAnalyticsEnabled() ? 'gtag is unavailable' : 'GA4 is disabled outside the production hostname');
    return false;
  }

  const payload = {
    page_location: window.location.href,
    page_title: document.title,
  };
  window.gtag('event', 'page_view', payload);
  console.info('[GA4] Sent page_view', payload);
  return true;
}

export function trackPurchase({ registration, payment, plan }) {
  const amount = Number(payment?.payAmount);
  if (!canTrack()) {
    logSkipped('purchase', isAnalyticsEnabled() ? 'gtag is unavailable' : 'GA4 is disabled outside the production hostname');
    return false;
  }

  if (!registration?.number || !plan?.id || !plan?.name || !Number.isFinite(amount)) {
    logSkipped('purchase', 'the successful submission or plan data is incomplete');
    return false;
  }

  const membershipTerm = payment.pay2YearsUpfront ? '2 Years Upfront' : '1 Year';
  const payload = {
    transaction_id: registration.number,
    value: amount,
    currency: 'AUD',
    items: [
      {
        item_id: plan.id,
        item_name: `${plan.name} - ${membershipTerm}`,
        price: amount,
        quantity: 1,
      },
    ],
  };
  window.gtag('event', 'purchase', payload);
  console.info('[GA4] Sent purchase', payload);
  return true;
}
